@if (genders$ | async; as genders) {
  <ion-select interface="popover" [formControl]="control" [label]="label">
    @for (gender of genders; track gender) {
      <ion-select-option [value]="gender.id">{{ gender.gender }}</ion-select-option>
    }
  </ion-select>
}
